export default "__VITE_ASSET__82f68185__"